import { render, staticRenderFns } from "./CmgHero.vue?vue&type=template&id=1e6255c6&scoped=true&lang=pug&"
import script from "./cmg-hero.ts?vue&type=script&lang=ts&"
export * from "./cmg-hero.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHero.vue?vue&type=style&index=0&id=1e6255c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6255c6",
  null
  
)

export default component.exports